/*

Sample custom page settings object:
{
    "path": "/canli-bahisler/futbol/streamsiz/ilk-yari-10",
    "settings": {
        "fontSize": "18",
        "pageChangeTime": "30",
        "matchTimeRange": "24",
        "goalEffect": false
    }
}

*/

export const Settings = {
    global: {
        initialValues: {
            fontSize: "big",
            pageChangeTime: 45,
            matchTimeRange: 24,
            goalEffect: false
        }
    },
    pageList: []
};

export const SettingsOptions = {
    options: {
        fontSize: {
            isActive: true,
            options: [
                {
                    id: 1,
                    label: "Küçük",
                    value: "small"
                },
                {
                    id: 2,
                    label: "Büyük",
                    value: "big"
                }
            ]
        },
        pageChangeTime: {
            isActive: true,
            options: [
                { id: 1, value: 10 },
                { id: 2, value: 20 },
                { id: 3, value: 30 },
                { id: 4, value: 45 },
                { id: 5, value: 60 },
                { id: 6, value: 90 },
                { id: 7, value: 120 },
                { id: 8, value: 150 }
            ]
        },
        matchTimeRange: {
            isActive: true,
            options: [
                { id: 1, value: 3 },
                { id: 2, value: 6 },
                { id: 3, value: 8 },
                { id: 4, value: 12 },
                { id: 5, value: 24 }]
        },
        goalEffect: {
            isActive: true
        }
    }
};
